export default __webpack_public_path__ + "static/media/231.92c5221b.png";